import React from 'react';
import './ConfirmModal.scss';

/**
 * 확인 버튼을 눌러야 닫히는 팝업 (Confirm Modal)
 * 
 * @param {boolean} isOpen - 모달 표시 여부
 * @param {string} type - 'success', 'warning', 'error', 'info'
 * @param {string} title - 제목
 * @param {string} message - 메시지
 * @param {string} subMessage - 부가 메시지
 * @param {string} confirmText - 확인 버튼 텍스트 (default: '확인')
 * @param {string} cancelText - 취소 버튼 텍스트 (default: '취소', showCancel이 true일 때만)
 * @param {boolean} showCancel - 취소 버튼 표시 여부 (default: false)
 * @param {function} onConfirm - 확인 콜백
 * @param {function} onCancel - 취소/닫기 콜백
 * @param {boolean} canCloseOutside - 외부 클릭으로 닫기 가능 여부 (default: false)
 */
const ConfirmModal = ({
  isOpen,
  type = 'info',
  title,
  message,
  subMessage,
  confirmText = '확인',
  cancelText = '취소',
  showCancel = false,
  onConfirm,
  onCancel,
  canCloseOutside = false,
  confirmDisabled = false,
  size = showCancel ? 'md' : 'sm',
  align = showCancel ? 'popup' : 'dialog',
  className = ''
}) => {
  if (!isOpen) return null;

  const isActionDisabled = Boolean(confirmDisabled);

  return (
    <div
      className="confirm-modal-overlay"
      onClick={canCloseOutside && !isActionDisabled ? onCancel : undefined}
    >
      <div
        className={`confirm-modal-content confirm-modal-content-${type} confirm-modal-content--${size} confirm-modal-content--${align}${className ? ` ${className}` : ''}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="confirm-modal-header">
          <h2>{title}</h2>
        </div>

        <div className="confirm-modal-body">
          <div className={`confirm-modal confirm-modal-${type}`}>
            <div className="confirm-modal-text-wrapper">
              <p className="confirm-modal-message">{message}</p>
              {subMessage && (
                <p className="confirm-modal-sub-message">{subMessage}</p>
              )}
            </div>
          </div>
        </div>

        <div className="confirm-modal-footer">
          {showCancel && onCancel && (
            <button
              className="btn btn-cancel"
              onClick={onCancel}
              type="button"
              disabled={isActionDisabled}
            >
              {cancelText}
            </button>
          )}
          {onConfirm && (
            <button
              className={`btn btn-primary btn-confirm${type === 'error' ? ' btn-confirm-danger' : ''}`}
              onClick={onConfirm}
              type="button"
              disabled={isActionDisabled}
            >
              {confirmText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
